module.exports = __webpack_public_path__ + "img/伯才一手单.628e39ec.svg";